export type ReferenceRate =
  | "BBSW"
  | "NZD_BBSW"
  | "Fed_Funds_Rate"
  | "LIBOR"
  | "EUIRBOR"
  | "JIBOR"
  | "TIBOR"
  | "SHIBOR"
  | "SIBOR";

export const referenceRateLookup: Record<ReferenceRate, string> = {
  BBSW: "BBSW",
  NZD_BBSW: "NZD BBSW",
  Fed_Funds_Rate: "Fed Funds Rate",
  LIBOR: "LIBOR",
  EUIRBOR: "EURIBOR",
  JIBOR: "JIBOR",
  TIBOR: "TIBOR",
  SHIBOR: "SHIBOR",
  SIBOR: "SIBOR",
};
